import { render, staticRenderFns } from "./AssinaturaDigitalPCM.vue?vue&type=template&id=14ef9944&scoped=true"
import script from "./AssinaturaDigitalPCM.vue?vue&type=script&lang=ts"
export * from "./AssinaturaDigitalPCM.vue?vue&type=script&lang=ts"
import style0 from "./AssinaturaDigitalPCM.vue?vue&type=style&index=0&id=14ef9944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef9944",
  null
  
)

export default component.exports